




























































import { Component, Model, Prop, Vue, } from "vue-property-decorator";
import { inject } from "inversify-props";
import { auth } from "@/store/modules";
import { IAuthService, IDoctorService } from '@/interfaces/Services';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { DoctorModel, ExportLock } from "@/models/doctor";

@Component({})
class SideMenu extends Vue {
  @inject(DependencyIdentifiers.AuthService) private authService!: IAuthService;
  @inject(DependencyIdentifiers.DoctorService) private doctorService!: IDoctorService;
  @Prop({required: true})
  private enabled!: boolean;

  // Only the icons are visible (used on desktop mode)
  @Prop({required: true})
  private minified!: boolean;

  // The menu can be drawn as offcanvas or as an overlay.
  @Prop({required: true})
  private temporary!: boolean;

  groupedLinks: any[] = [];

  async logout() {
    await this.authService.logout();
    this.$router.push({ path:'/' });
  }

  async created() {
    console.log(`[Menu] hasExportLock=${auth.hasExportLock}, isDoctor=${auth.isDoctor}, isManager=${auth.isManager}.`);

    const userGroup = [
      {
        to: "/dashboard/profile",
        icon: "fa-user",
        text: this.$t('general.titles.settings')
      },
    ];

    if (auth.isDoctor && !auth.hasExportLock) {
      userGroup.push({
        to: "/dashboard/events",
        icon: "fa-calendar-day",
        text: this.$t('general.titles.events')
      });
    }

    const centerGroup = [];
    if (auth.isDoctor && auth.isPrimaryCenter && auth.isManager && !auth.hasExportLock) {
      centerGroup.push({
        to: "/dashboard/centers",
        icon: "fa-hospital",
        text: this.$t('general.titles.centers'),
        if: "primary"
      });
    }
    if (auth.isDoctor && !auth.hasExportLock) {
      centerGroup.push(
        {
          to: "/dashboard/doctors",
          icon: "fa-user-md",
          text: this.$t('general.titles.doctors')
        },
        {
          to: "/dashboard/patients",
          icon: "fa-user-injured",
          text: this.$t('general.titles.patients')
        }
      );
    }

    const debugGroup: any[] = [
      // {
      //   to: "/dashboard/drugs",
      //   icon: "fa-pills",
      //   text: this.$t('general.titles.drugs')
      // }
      // {
      //   to: "/dashboard/events/stat",
      //   icon: "fa-table",
      //   text: this.$t('general.titles.eventStats')
      // }
    ];

    const exportGroup: any[] = [];
    if (auth.isDoctor) {
      exportGroup.push({
        to: "/dashboard/export/events",
        icon: "fa-file-export",
        text: this.$t('general.titles.eventExport')
      });
    }

    this.groupedLinks = [userGroup, centerGroup, debugGroup, exportGroup];
  }
}

export default SideMenu;
